<div class="flex flex-column">
  <div>
    <p [innerHtml]="message"></p>
    <app-input [placeholder]="placeholder" [maxLength]="maxLength" [showLength]="showLength" [type]="inputType"
      [inputWidth]="inputWidth"
    [(model)]="value" label=""></app-input>
  </div>


  <div class="grid mt-4">
    <div class="col-6">
      <button pButton class="p-button-outlined" [icon]="cancelIcon" [label]="cancelLabel"
      (click)="close()"></button>
    </div>
    <div class="col-6">
      @if (maxLength && value?.length > maxLength) {
        <p-tag severity="warn" value="Testo troppo lungo"></p-tag>
      }
      <button pButton class="p-button-raised" [icon]="confirmIcon" [label]="confirmLabel" (click)="confirm()"
        [disabled]="maxLength && value?.length > maxLength"
      style="float: right"></button>
    </div>
  </div>
</div>
